import { render, staticRenderFns } from "./listItem.vue?vue&type=template&id=fae8633c&scoped=true&"
import script from "./listItem.vue?vue&type=script&lang=js&"
export * from "./listItem.vue?vue&type=script&lang=js&"
import style0 from "./listItem.vue?vue&type=style&index=0&id=fae8633c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fae8633c",
  null
  
)

export default component.exports